<script setup>
const props = defineProps({
  data: Object,
  pulseData: Object
})
const { getRecShared } = useLeadGenRecData();
const { data: recSharedData } = await getRecShared();
const emit = defineEmits('validateStep');
const placeholderText = props.data.sharedContent ? recSharedData.value.data.attributes.parentName : props.data.placeholderText;
const errorText = props.data.sharedContent ? recSharedData.value.data.attributes.parentNameError : props.data.errorText;
const firstName = ref(null);
const parentName = toRef(props, 'pulseData');


const onFieldChanged = (field) => {
  firstName.value = field.value;
  parentName.value.firstName = firstName.value;
   emit('validateStep', {
  value: firstName.value,
  component: props.data.component
});
}
const onKeyPress = (field) => {
  firstName.value = field.value;
  emit('validateStep', {
  value: firstName.value,
  component: props.data.component
});
}

onMounted(() => {
  const parentElement = document.getElementById('course-rec-parent-name').parentElement.parentElement.parentElement
  
  const observer = new MutationObserver((mutationsList, observer) => {
    for (var mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style' && parentElement.style.display !== 'none') {
        emit('validateStep', {
  value: firstName.value,
  component: props.data.component
});
      }
    }
  });
  observer.observe(parentElement, { attributes: true});
})
</script>

<template>
  <form id="course-rec-parent-name" @submit.prevent>
    <fieldset>
      <div class="col mx-3">
        <FormFloatingLabelInput :id="'parentName'" :placeholderText="placeholderText" :errorText="errorText" :required="false"
        @onChanged="onFieldChanged" @onKeyPress="onKeyPress"/>
      </div>
    </fieldset>
  </form>
</template>

<style lang="scss">
#course-rec-parent-name {
  .form-floating {
    @include media-breakpoint-up(sm) {
      width: 350px;
      margin: 0 auto;;
    }
  }
}
</style>